<template>
  <div class="box">
    <div class="title">即可获取福利和专属1对1服务</div>
    <!-- 中间 -->
    <div class="zhongjian">
      <img src="@/image/home/yuyuan@2x.png" alt="" />

      <!-- 表单------- -->
      <div class="biaodan">
        <input class="inpt" type="text" name="" placeholder="姓名" oninput="value=value.replace(/[^\u4E00-\u9FA5]/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')" id="" v-model="name" />
        <input class="inpt" type="number" name="" placeholder="手机号" @blur="checkPhone()" id="telephone" v-model="phone" />
        <input class="inpt" type="text" name="" placeholder="公司名称(选填)" id="" v-model="company" />
        <input class="inpt" type="text" name="" placeholder="地区" id="" v-model="region" />
        <!-- 按钮 -->
        <div class="bnt" @click="postconsult">免费咨询</div>

        <!-- 底部时间 -->
        <div class="time">
          <div class="lift">{{ userInfo.sll_tel }}</div>

          <div class="right">
            <div class="r1">周一至周五9:00-22:00</div>
            <div>周六至周日9:00-18:00</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="bootm">
      <!-- 底部一 -->
      <!-- 左边 -->
      <div class="b-box">
        <div class="b-left">
          <img src="@/image/home/LOGO_di@2x.png" alt="" />

          <!-- 下拉栏 -->
          <div class="xiala">
            <!-- 下拉栏 1-->
            <div class="show" @mouseover="b_show1 = true" @mouseleave="b_show1 = false">
              <div class="shbox" v-show="b_show1">
                <div class="shh">
                  <div class="sh" v-for="item in government" :key="item.name">
                    <a :href="item.url" target="_black">{{ item.name }}</a>
                  </div>
                </div>
              </div>
              <div class="tit">政府链接 <i class="is" :class="b_show1 == 0 ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i></div>
            </div>
            <!-- 下拉栏 2-->
            <div class="show" @mouseover="b_show2 = true" @mouseleave="b_show2 = false">
              <div class="shbox" v-show="b_show2">
                <div class="shh">
                  <div class="sh" v-for="item in media" :key="item.name">
                    <a :href="item.url" target="_black">{{ item.name }}</a>
                  </div>
                </div>
              </div>
              <div class="tit">媒体链接 <i class="is" :class="b_show2 == 0 ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i></div>
            </div>
          </div>
          <!-- 下拉栏 -->
        </div>

        <!-- 右边 -->
        <div class="b-right">
          <div class="r1">
            <div class="t1">{{ service.name }}</div>

            <div class="t2box">
              <div class="t2" v-for="item in service.chlid" :key="item.id">
                <router-link :to="item.url">{{ item.name }}</router-link>
              </div>
            </div>
          </div>

          <div class="r1">
            <div class="t1">行业案例</div>
            <div class="t2box2">
              <div class="t2">房产家居</div>
              <div class="t2">旅游服务</div>
              <div class="t2">网络服务</div>
              <div class="t2">教育培训</div>
              <div class="t2">商务服务</div>
              <div class="t2">IT/互联网</div>
              <div class="t2">汽车</div>
            </div>
          </div>

          <div class="r1">
            <div class="t1">{{ contact.name }}</div>

            <div class="t2box">
              <div class="t2" v-for="item in contact.chlid" :key="item.id">
                <router-link :to="item.url">{{ item.name }}</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部二 -->

      <div class="b-box2">
        <div class="t3">{{ userInfo.name }} ICP证：{{ userInfo.icp }}</div>
        <div class="t4">晋公安网备 {{ userInfo.police_no }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DczxxFooter',

  data() {
    return {
      b_show1: false,
      b_show2: false,
      userInfo: {
        name: '',
        icp: '',
        police_no: '',
        sll_tel: '',
      },
      government: [],
      media: [],

      // 咨询
      name: '',
      phone: '',
      company: '',
      region: '',

      service: '',
      contact: '',
    }
  },

  mounted() {
    this.getwebConfig()
    this.getoutsideLink()
    this.getmenu()
  },

  methods: {
    //手机号校验
    checkPhone() {
      //定义phone，通过唯一id拿到input框输入的值
      const phone = document.getElementById('telephone').value
      if (!/^1[34578]\d{9}$/.test(phone)) {
        //手机号正则校验
        if (phone === '') {
          //若手机号为空
          this.$showToast.show('手机号不能为空')
          setTimeout(() => {
            this.$showToast.hide()
          }, 1500)
          return false
        } else {
          //手机号非空的报错信息
          this.$showToast.show('手机号码格式错误')
          setTimeout(() => {
            this.$showToast.hide()
          }, 1500)
          return false
        }
      } else {
        //手机号正确则无错误信息
        return true
      }
    },
    getwebConfig() {
      this.$axios
        .get('/index/Dt/webConfig', {
          headers: {
            Authorization: 'www.ditingzixun.cn',
          },
        })
        .then((res) => {
          this.userInfo.name = res.data.data.company_name
          this.userInfo.icp = res.data.data.icp_no
          this.userInfo.police_no = res.data.data.police_no
          this.userInfo.sll_tel = res.data.data.sll_tel
        })
    },
    getoutsideLink() {
      this.$axios
        .get('/index/Dt/outsideLink', {
          headers: {
            Authorization: 'www.ditingzixun.cn',
          },
        })
        .then((res) => {
          this.government = res.data.data.government
          this.media = res.data.data.media
        })
    },
    getmenu() {
      this.$axios
        .get('/index/Dt/menu', {
          headers: {
            Authorization: 'www.ditingzixun.cn',
          },
        })
        .then((res) => {
          this.service = res.data.data[2]
          this.contact = res.data.data[6]
        })
    },
    postconsult() {
      if (this.name == '') {
        this.$showToast.show('姓名不能为空')
        setTimeout(() => {
          this.$showToast.hide()
        }, 1500)
        return false
      }
      if (this.phone == '') {
        this.$showToast.show('手机号不能为空')
        setTimeout(() => {
          this.$showToast.hide()
        }, 1500)
        return false
      }
      if (this.region == '') {
        this.$showToast.show('地区不能为空')
        setTimeout(() => {
          this.$showToast.hide()
        }, 1500)
        return false
      }
      this.$axios
        .post(
          '/index/Dt/consult',
          {
            username: this.name,
            mobile: this.phone,
            company: this.company,
            area: this.region,
          },
          {
            headers: {
              Authorization: 'www.ditingzixun.cn',
            },
          }
        )
        .then((res) => {
          this.$showToast.show('提交成功')
          setTimeout(() => {
            this.$showToast.hide()
          }, 1500)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
a {
  color: #bbb;
}
.box {
  width: 100%;
}
.title {
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  // font-weight: 500;
  font-size: 36px;
}

.zhongjian {
  margin-top: 100px;
  height: 500px;
  position: relative;
  img {
    height: 100%;
    width: 100%;
  }

  .biaodan {
    box-sizing: border-box;
    padding-top: 10px;
    position: absolute;
    top: -60px;
    left: 1000px;
    height: 500px;
    width: 380px;
    background-color: #ffffff;
    border-radius: 12px;
    box-shadow: 0px 0px 4px 3px #efefef;

    .inpt {
      outline: none;

      width: 320px;
      height: 42px;
      border: 0;
      background-color: #fafafa;
      margin: 28px 30px 0 30px;
      border-radius: 4px;
      padding-left: 15px;
      box-sizing: border-box;
    }

    .bnt {
      width: 320px;
      height: 42px;
      background-color: #4581fb;
      line-height: 42px;
      text-align: center;
      color: #fff;
      margin: 30px 38px 0 30px;
    }

    .time {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 100px;
      background-color: #f7f7f7;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .lift {
        font-size: 20px;
      }

      .right {
        font-size: 12px;
        color: #999999;
        .r1 {
          margin-bottom: 5px;
        }
      }
    }
  }
}

.bootm {
  height: 380px;
  width: 100%;
  background-color: #000;

  .b-box {
    height: 75%;
    border-bottom: 1px solid #bbbbbb;
    display: flex;

    .b-left {
      // border: 1px solid #efefef;
      width: 45%;
      img {
        margin-top: 52px;
        margin-left: 438px;
      }

      //下拉栏

      .xiala {
        margin-top: 40px;
        margin-left: 438px;
        display: flex;
      }
      .show {
        color: #fff;
        // margin-top: 40px;
        // margin-left: 408px;
        // background-color: #444444;
        position: relative;
        width: 128px;
        margin-left: 10px;
        padding-top: 10px;
        .shbox {
          position: absolute;

          color: #bbbbbb;
          bottom: 100%;
          .shh {
            background-color: #444444;
            text-align: center;
            padding: 8px 0;
            .sh {
              width: 128px;
              margin: 10px 0;
              font-size: 14px;
            }
            .sh a:hover {
              color: #fff;
            }
          }
        }
        .tit {
          // position: absolute;
          // bottom: 0;
          text-align: center;
          padding: 5px 0;
          background-color: #444444;
          .is {
            margin-left: 5px;
          }
        }
      }
    }

    .b-right {
      padding-top: 13px;
      width: 30%;
      color: #fff;
      display: flex;
      justify-content: space-between;

      .r1 {
        margin-top: 7%;

        .t1 {
          font-weight: 600;
          font-size: 16px;
          font-family: PingFang-SC-Medium;
        }
        .t2box {
          margin-top: 12px;
          font-size: 14px;
          color: #bbbbbb;
          .t2 {
            margin: 2px 0 8px 0;
          }
        }

        .t2box2 {
          margin-top: 12px;
          font-size: 14px;
          color: #bbbbbb;
          // border: 1px solid;
          width: 180px;
          flex-wrap: wrap;
          display: flex;
          // justify-content: space-between;
          .t2 {
            margin: 2px 30px 8px 0;
          }
        }
      }
    }
  }

  .b-box2 {
    width: 100%;

    text-align: center;
    color: #bbbbbb;
    .t3 {
      margin-top: 15px;
    }
    .t4 {
      margin-top: 15px;
    }
  }
}
</style>
